/**
 * W3.BUG-1: Labels for intentional multi-destination fan-out on one library post.
 * Facebook Page + IG dual-publish + group share ≠ triple Celery Page publishes.
 */

function igMediaId(post) {
  const ig = post?.platform_specific?.instagram;
  if (!ig || typeof ig !== 'object') return null;
  const raw = ig.media_id || ig.id;
  return raw ? String(raw).trim() : null;
}

export function describePublishDestinations(post) {
  if (!post) return [];
  const platform = String(post.platform || '')
    .trim()
    .toLowerCase();
  const labels = [];

  if (platform) {
    if (platform === 'facebook' || platform === 'facebook_page') {
      labels.push('Facebook Page');
    } else {
      labels.push(
        platform
          .replace(/_/g, ' ')
          .replace(/\b\w/g, (c) => c.toUpperCase())
      );
    }
  }

  const hasIg =
    Boolean(igMediaId(post)) ||
    (Boolean(post?.platform_specific?.instagram) &&
      (platform === 'facebook' || platform === 'facebook_page'));
  if (hasIg && !labels.some((l) => l.startsWith('Instagram'))) {
    labels.push('Instagram (via Facebook)');
  }

  let gs = post.group_share;
  if ((!gs || typeof gs !== 'object') && post?.platform_specific?.facebook) {
    gs = post.platform_specific.facebook.group_share;
  }
  if (gs && typeof gs === 'object') {
    const ok = Number(gs.ok_count || 0);
    const total =
      Number(gs.total || 0) ||
      (Array.isArray(gs.results) ? gs.results.length : 0);
    if (total || gs.error || (gs.results || []).length) {
      labels.push(total ? `Groups (${ok}/${total})` : 'Groups');
    }
  }

  return labels;
}
